import { createSlice } from "@reduxjs/toolkit";
import { fetchInsuranceTaskStatus } from "../documentUploadApi";

const fetchInsuranceTaskStatusSlice = createSlice({
    name: "insuranceTaskStatus",
    initialState: {
        status: null, // current status: 'idle' | 'loading' | 'succeeded' | 'failed'
        data: null,
        loading: false,
        error: null,
    },
    reducers: {
        resetInsuranceTaskStatus: (state) => {
            state.status = null;
            state.data = null;
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchInsuranceTaskStatus.pending, (state) => {
                state.loading = true;
                state.status = "loading";
            })
            .addCase(fetchInsuranceTaskStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.status = "succeeded";
                state.data = action.payload;
            })
            .addCase(fetchInsuranceTaskStatus.rejected, (state, action) => {
                state.loading = false;
                state.status = "failed";
                state.error = action.payload;
            });
    },
});

export const { resetInsuranceTaskStatus } = fetchInsuranceTaskStatusSlice.actions;
export default fetchInsuranceTaskStatusSlice.reducer;

